import React from "react";
import { Trash2, Edit, FileText } from "lucide-react";

function ExpensesList({ expenses, onDelete, onEdit }) {
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return dateString;
  };

  const formatAmount = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2
    }).format(amount || 0);
  };

  const getTotalAmount = () => {
    return expenses.reduce((sum, expense) => sum + (parseFloat(expense.amount) || 0), 0);
  };

  if (!expenses || expenses.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-400 text-lg">No expenses added yet</p>
        <p className="text-gray-500 text-sm mt-2">Click "Add Expense" to create your first expense entry</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {/* Expenses Table */}
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-700">
              <th className="text-left py-3 px-4 text-gray-400 font-medium">Date</th>
              <th className="text-left py-3 px-4 text-gray-400 font-medium">Type</th>
              <th className="text-left py-3 px-4 text-gray-400 font-medium">Description</th>
              <th className="text-right py-3 px-4 text-gray-400 font-medium">Amount</th>
              <th className="text-center py-3 px-4 text-gray-400 font-medium">Billable</th>
              <th className="text-center py-3 px-4 text-gray-400 font-medium">Action</th>
            </tr>
          </thead>
          <tbody>
            {expenses.map((expense, index) => (
              <tr
                key={expense.id || index}
                className="border-b border-gray-800 hover:bg-gray-800/30 transition-colors"
              >
                <td className="py-3 px-4 text-white">{formatDate(expense.date)}</td>
                <td className="py-3 px-4">
                  <span className="inline-block px-3 py-1 bg-blue-600/20 text-blue-400 rounded-full text-sm">
                    {expense.type}
                  </span>
                </td>
                <td className="py-3 px-4 text-gray-300">
                  <div>{expense.description || "N/A"}</div>
                  {expense.attachments && expense.attachments.length > 0 && (
                    <div className="flex items-center gap-1 mt-1">
                      <FileText size={14} className="text-blue-400" />
                      <span className="text-xs text-blue-400">
                        {expense.attachments.length} attachment{expense.attachments.length > 1 ? 's' : ''}
                      </span>
                    </div>
                  )}
                </td>
                <td className="py-3 px-4 text-right text-white font-medium">
                  {formatAmount(expense.amount)}
                </td>
                <td className="py-3 px-4 text-center">
                  {expense.billable ? (
                    <span className="inline-block px-3 py-1 bg-green-600/20 text-green-400 rounded-full text-sm">
                      Billable
                    </span>
                  ) : (
                    <span className="inline-block px-3 py-1 bg-gray-600/20 text-gray-400 rounded-full text-sm">
                      Non-Billable
                    </span>
                  )}
                </td>
                <td className="py-3 px-4 text-center">
                  <div className="flex items-center justify-center gap-2">
                    {/* Edit button commented out
                    <button
                      onClick={() => onEdit(expense)}
                      className="text-blue-400 hover:text-blue-300 transition-colors p-2 hover:bg-blue-900/20 rounded"
                      title="Edit expense"
                    >
                      <Edit size={18} />
                    </button>
                    */}
                    <button
                      onClick={() => onDelete(expense.id || index)}
                      className="text-red-400 hover:text-red-300 transition-colors p-2 hover:bg-red-900/20 rounded"
                      title="Delete expense"
                    >
                      <Trash2 size={18} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="border-t-2 border-gray-600">
              <td colSpan="3" className="py-4 px-4 text-right text-gray-400 font-semibold">
                Total:
              </td>
              <td className="py-4 px-4 text-right text-[#C99F4A] font-bold text-lg">
                {formatAmount(getTotalAmount())}
              </td>
              <td></td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}

export default ExpensesList;
